/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-04-30 11:29:14
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-07-08 17:12:08
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelLegal/TermsAndConditionEditor/slice/index.ts
 */
import {
  createAsyncThunk,
  createSelector,
  createSlice,
} from '@reduxjs/toolkit';
import {
  getCollapse as _getCollapse,
  getHasModified as _getHasModified,
  getLastModified as _getLastModified,
  getLoaded as _getLoaded,
  getState as _getState,
  getUuid as _getUuid,
  reducerTarget,
  willUnmount,
  getTranslationState as _getTranslationState,
} from 'src/pages/SalesCannelVersion/SalesChannelLegal/slice/common';
import { EnumReducers } from 'src/pages/SalesCannelVersion/SalesChannelLegal/slice/constants';
import { assData, clearError, timeoutScroll as scroll } from 'src/tools/helper';
import {
  EnumCollapseId,
  common,
  defaultStatus,
  generateCollapseOpen,
  generateContent,
  generateLegalSetting,
  generatePageSetting,
} from '../common';
export { EnumCollapseId };
//import { generateErrorKey } from 'src/tools/helper';
import { getI18nFromGeneral } from '@/src/tools/tools';
import { isCurrentPrimary } from 'src/constrains/SalesChannelMultiLanguageSelect';
import { duplicateErrCode } from 'src/pages/SalesCannelVersion/SalesChannelLegal/tools';
import { getTC, postTC, postTranslateTC } from 'src/request/salesChannel/legal';
import { msg } from 'src/tools/message';
import { modal } from 'src/utils/Modal';
import {
  validation as _validation,
  convertDataFromServerToRedux,
} from '../tools';

export const fetchTermsAndCondition = createAsyncThunk(
  'fetchTermsAndConditionEditorDetail',
  async (data: any) => {
    const { uuid, params, isClone } = data;
    const isPrimary = isCurrentPrimary();
    const response = await getTC(uuid, params);
    return { response, isPrimary, isClone };
  },
);

export const submitTermsAndCondition = createAsyncThunk(
  'submitTermsAndConditionEditorDetail',
  async (obj: any) =>
    //thunkAPI,
    {
      const { data, params } = obj;
      const isPrimary = isCurrentPrimary();
      const response = await postTC(data, {
        ...(params || {}),
        handleErrorAsResolve: true,
      });
      return { response, isPrimary };
    },
);

export const translateTermsAndCondition = createAsyncThunk(
  'translateTermsAndConditionEditorDetail',
  async ({ uuid, translationEnabled, multiLanguageParams }: any) => {
    const response = await postTranslateTC(
      uuid,
      translationEnabled,
      multiLanguageParams,
    );
    return { response, translationEnabled };
  },
);

const legalEditorReducers = (state, reducer) => {
  const reducers = [EnumReducers.termsAndConditionEditor, reducer];
  const _r = reducerTarget(state, reducers);
  return _r;
};

const collapseOpen = generateCollapseOpen([
  EnumCollapseId.PageSetting,
  EnumCollapseId.LegalSetting,
  EnumCollapseId.Content,
]);
const pageSetting = generatePageSetting();

const legalSetting = generateLegalSetting();
const content = generateContent();
const defaultState = {
  ...common,
  ...defaultStatus,
  collapseOpen,
  pageSetting,
  legalSetting,
  content,
  translationEnabled: false,
  translationLoading: false,
};
const salesChannelLegalTermsAndConditionEditorEditor = createSlice({
  name: 'salesChannelLegalTermsAndConditionEditorEditor',
  initialState: defaultState,
  reducers: {
    updateEssentialData(state, action) {
      const { salesChannelUuid, index } = action.payload;
      state.salesChannelUuid = salesChannelUuid;
      state.pageSetting.name = 'Terms & Conditions ' + index || '1';
      state.loaded = true;
    },

    resetData(state) {
      willUnmount({ state, defaultState });
    },

    onCollapseChange(state, action) {
      const { id, status } = action.payload;
      state.collapseOpen[id] = status;
    },

    onPageSettingChange(state, action) {
      state.hasModified = true;

      state.pageSetting = {
        ...state.pageSetting,
        ...clearError(action.payload),
      };
    },

    onLegalSettingChange(state, action) {
      state.hasModified = true;

      state.legalSetting = {
        ...state.legalSetting,
        ...clearError(action.payload),
      };
    },

    onContentChange(state, action) {
      state.hasModified = true;
      state.content = {
        ...state.content,
        ...clearError(action.payload),
      };
    },

    validation(state, action) {
      state.dataValid = _validation(state, action.payload);
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchTermsAndCondition.rejected, (state) => {
      state.loaded = true;
    });
    builder.addCase(fetchTermsAndCondition.pending, (state) => {
      state.loaded = false;
    });
    builder.addCase(fetchTermsAndCondition.fulfilled, (state, action) => {
      const { response, isClone } = action.payload;

      const _data = convertDataFromServerToRedux(response || {}) || {};

      assData(state, _data);
      if (isClone) state.hasModified = true;
    });

    builder.addCase(submitTermsAndCondition.pending, (state) => {
      state.loaded = false;
    });
    builder.addCase(submitTermsAndCondition.rejected, (state, action) => {
      state.loaded = true;
    });
    builder.addCase(submitTermsAndCondition.fulfilled, (state, action) => {
      const { response } = action.payload;
      const { __requestRejected, errorCode, errorDesc } = response;
      state.loaded = true;

      if (__requestRejected) {
        if (errorCode == duplicateErrCode) {
          state.pageSetting['nameIsValid'] = false;
          state.timeoutRef.push(
            scroll('SalesChannelLegalTermsAndConditionEditorPageName'),
          );
        } else {
          modal.error({
            title: getI18nFromGeneral('general.tools_server.requestError'),
            content: errorDesc || 'System Error, Please Contact Admin',
            onCancel: () => {
              console.error(errorDesc || 'System Error, Please Contact Admin');
            },
            onCancelText: 'Confirm',
          });
        }
      } else {
        const _data: any = convertDataFromServerToRedux(response) || {};
        msg.success(
          getI18nFromGeneral('general.status.changessavesuccessfully'),
        );
        assData(state, { ..._data });
      }
      // const { response } = action.payload;
    });
    builder
      .addCase(translateTermsAndCondition.pending, (state) => {
        state.translationLoading = true;
      })
      .addCase(translateTermsAndCondition.fulfilled, (state, action) => {
        state.translationLoading = false;
        const { response, translationEnabled } = action.payload;
        if (response) {
          state.hasModified = false;
          state.translationEnabled = translationEnabled;
        }
      })
      .addCase(translateTermsAndCondition.rejected, (state) => {
        state.translationLoading = false;
      });
  },
});
export const {
  resetData,
  onCollapseChange,
  onPageSettingChange,
  onLegalSettingChange,
  onContentChange,
  validation,
  updateEssentialData,
} = salesChannelLegalTermsAndConditionEditorEditor.actions;

const getPageSetting = () => {
  return createSelector(
    (state: any) => legalEditorReducers(state, 'pageSetting'),
    (pageSetting) => {
      return pageSetting;
    },
  );
};

const getPageName = () => {
  return createSelector(
    (state: any) => legalEditorReducers(state, 'pageSetting').name,
    (state: any) => legalEditorReducers(state, 'salesChannelName'),
    (name, salesChannelName) => {
      return { name, salesChannelName };
    },
  );
};

const getLegalSetting = () => {
  return createSelector(
    (state: any) => legalEditorReducers(state, 'legalSetting'),
    (legalSetting) => {
      return legalSetting;
    },
  );
};

const getContent = () => {
  return createSelector(
    (state: any) => legalEditorReducers(state, 'content'),
    (state: any) => legalEditorReducers(state, 'loaded'),
    (content, loaded) => {
      return { content, loaded };
    },
  );
};

const getCollapse = (id) => {
  return _getCollapse(EnumReducers.termsAndConditionEditor, id);
};

const getState = () => {
  return _getState(EnumReducers.termsAndConditionEditor);
};

const getHasModified = () => {
  return _getHasModified(EnumReducers.termsAndConditionEditor);
};

const getUuid = () => {
  return _getUuid(EnumReducers.termsAndConditionEditor);
};
const getLoaded = () => {
  return _getLoaded(EnumReducers.termsAndConditionEditor);
};

const getLastModified = () => {
  return _getLastModified(EnumReducers.legalEditor);
};
export const getTranslationState = () => {
  return _getTranslationState(EnumReducers.termsAndConditionEditor);
};
export {
  getCollapse,
  getContent,
  getHasModified,
  getLastModified,
  getLegalSetting,
  getLoaded,
  getPageName,
  getPageSetting,
  getState,
  getUuid,
};

export default salesChannelLegalTermsAndConditionEditorEditor.reducer;
